// import { title, defaultFont } from "./common-style";
import orange from "@material-ui/core/colors/orange";

const jobDetailStyle = theme => ({
  main: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingBottom: '50px'
  },
  adminContent: {
    width: "80%",
    margin: "0 auto",
    paddingTop: "75px",
    marginBottom: "20px",
    borderRadius: "8.9px",
    boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
    backgroundColor: "#ffffff"
  },
  content: {
    width: "80%",
    margin: "0 auto",
    paddingTop: "50px",
    marginBottom: "20px",
    borderRadius: "8.9px",
    boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
    backgroundColor: "#ffffff"
  },
  title: {
    fontFamily: "Poppins",
    fontSize: "21px",
    fontWeight: 500,
    textAlign: "left",
    color: "#004e96",
    margin: "0 auto",
    marginBottom: "20px"
  },
  entity: {
    fontFamily: "Poppins",
    fontSize: "17px",
    fontWeight: 500,
    textAlign: "left",
    color: "#000000",
    margin: "0 auto"
  },
  centeredTitle: {
    fontFamily: "Poppins",
    fontSize: "21px",
    fontWeight: 500,
    textAlign: "center",
    color: "#004e96",
    margin: "0 auto"
  },
  section: {
    padding: "28px 45px"
  },
  divider: {
    width: "100%",
    height: "1px",
    opacity: "0.5",
    backgroundColor: "#004e96",
    margin: "0 auto"
  },
  text: {
    fontFamily: "Poppins",
    fontSize: "17px",
    fontWeight: "300",
    lineHeight: "1.47",
    textAlign: "left",
    color: "#000000"
  },
  applyBtn: {
    color: "#FFFFFF",
    backgroundColor: orange[500],
    "&:hover": {
      backgroundColor: orange[700]
    },
    textTransform: "capitalize"
  },
  icon: {
    color: "#000",
    fontSize: "0.75rem",
    height: "21px",
    lineHeight: "21px"
  },
  subText: {
    marginLeft: "10px",
    marginRight: "15px"
  },
  img: {
    backgroundColor: "#333"
  },
  departmentText: {
    marginTop: "10px",
    marginBottom: "10px"
  },
  subtitle: {
    textTransform: "uppercase",
    paddingTop: "16px",
    paddingLeft: "16px"
  },
  btnText: {
    color: "#FFFFFF",
    fontSize: "1.25rem",
    fontWeight: "500"
  },
  paper: {
    position: "absolute",
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
    outline: "none"
  },
  input: {
    width: "100%",
    margin: "20px 0px",
  },
  checkboxInput: {
    display: 'inline-flex',
    width: '100%',
    margin: '10px 0px',
  },
  modal: {
    overflow: 'auto',
  },
  edit_button: {
    minWidth: "100px",
    textTransform: "none",
    marginLeft: 10,
    marginRight: 10
  },
  nav_button: {
    minWidth: "100px",
    textTransform: "none",
    marginLeft: 10,
    marginRight: 10
  },
});

export default jobDetailStyle;
